import { useCallback } from 'react';
import { usePermissionContext } from '../providers/PermissionProvider';

export function usePermissions() {
  const { permissions, role, loading, error, refreshPermissions } =
    usePermissionContext();

  const isPermissionsLoaded = !loading && !error;

  const can = useCallback(
    (requiredPermission) => {
      // If the user is the owner, grant full access
      if (role === 'owner') return true;

      if (!requiredPermission) return true;
      return permissions?.includes(requiredPermission) || false;
    },
    [permissions, role],
  );

  const canAny = useCallback(
    (requiredPermissions) => {
      if (!requiredPermissions || requiredPermissions.length === 0) return true;
      return requiredPermissions.some((perm) => can(perm));
    },
    [can],
  );

  const canAll = useCallback(
    (requiredPermissions) => {
      if (!requiredPermissions || requiredPermissions.length === 0) return true;
      return requiredPermissions.every((perm) => can(perm));
    },
    [can],
  );

  const hasModuleAccess = useCallback(
    (modulePermissionsObj) => {
      // Check if user has at least one permission in the given module
      if (!modulePermissionsObj) return true;
      const modulePerms = Object.values(modulePermissionsObj);
      return canAny(modulePerms);
    },
    [canAny],
  );

  return {
    can,
    canAny,
    canAll,
    hasModuleAccess,
    permissions,
    isPermissionsLoaded,
    permissionLoading: loading,
    permissionError: error,
    refreshPermissions,
    role,
  };
}
